/* eslint-disable no-underscore-dangle */
/* eslint-disable indent */
import {
  Button,
  Card,
  Checkbox,
  Dialog,
  Input,
  Message,
  Select,
} from '@alifd/next';
import { Form, message, Table } from 'antd';
import axios from 'axios';
import { history } from 'ice';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import ReactDragListView from 'react-drag-listview';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Option } = Select;
const BroadCastList = () => {
  const [form] = Form.useForm();
  const [BroadcastForm] = Form.useForm();
  const broadcast = client.service('broadcast');
  const broadcastBox = client.service('broadcastBoxs');
  const [broadcastData, setBroadcastData] = useState([]);
  const [broadcastBoxData, setBroadcastBoxData] = useState([]);
  const [settingBroadcast, setSettingBroadcast] = useState(false);
  const [checkBroadcastBox, setCheckBroadcastBox] = useState([]);
  const [settingBroadcastGroup, setSettingBroadcastGroup] = useState(false);
  const [broadcastGroup, setBroadcastGroup] = useState([]);
  const [broadcastGroupId, setBroadcastGroupId] = useState([]);
  const [broadcastStatus, setBroadcastStatus] = useState('insert');
  const [userName, setUserName] = useState('');
  const [broadcastValueDialog, setBroadcastValueDialog] = useState(false);
  const [newBroadcastData, setNewBroadcastData] = useState([]);
  const [broadcastContent, setBroadcastContent] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await broadcast.find({
        query: { broadcastGroup: { $exists: true } },
      });
      setBroadcastGroup(res.data.sort((a, b) => b.createdTime - a.createdTime));

      const res2 = await broadcast.find({
        query: { broadcastGroup: { $exists: false } },
      });
      setBroadcastData(
        res2.data.map((item) => {
          const newItem = {
            label: item.title,
            value: item._id,
            content: item,
          };
          return newItem;
        })
      );

      const res3 = await broadcastBox.find({});
      setBroadcastBoxData(
        res3.data.map((item) => {
          const newItem = {
            label: item.name,
            value: item._id,
          };
          return newItem;
        })
      );
      client.reAuthenticate().then((data) => {
        setUserName(data.user.name);
      });
    })();
  }, [broadcast, broadcastBox]);

  // 新增公播群組
  const onFinish = (value) => {
    const newBroadcastGroup = [];
    const newBroadcastId = [];
    for (let i = 0; i < newBroadcastData.length; i++) {
      broadcastData.map((item) => {
        if (item.value === newBroadcastData[i].value) {
          newBroadcastGroup.push(item.content);
          newBroadcastId.push(item.value);
        }
      });
    }
    if (newBroadcastData.length === 0) {
      Message.error('公播播放內容不可為空');
      return;
    }
    if (broadcastStatus === 'insert') {
      broadcast
        .create({
          ...value,
          broadcastGroupId: newBroadcastId,
          broadcastGroup: newBroadcastGroup,
          broadcastContent: newBroadcastData.map((x) => x),
          userName,
        })
        .then(() => {
          message.success('新增成功');
          setSettingBroadcastGroup(false);
          broadcast
            .find({
              query: { broadcastGroup: { $exists: true } },
            })
            .then((res) => {
              setBroadcastGroup(res.data);
            });
        })
        .catch((err) => {
          message.error(err);
        });
    } else {
      broadcast
        .patch(broadcastGroupId, {
          ...value,
          broadcastGroupId: newBroadcastId,
          broadcastGroup: newBroadcastGroup,
          broadcastContent: newBroadcastData.map((x) => x),
          userName,
        })
        .then(() => {
          setSettingBroadcastGroup(false);
          broadcast
            .find({
              query: { broadcastGroup: { $exists: true } },
            })
            .then((res) => {
              setBroadcastGroup(res.data);
            });
        })
        .catch((err) => {
          message.error(err);
        });
      Message.success('資料更新成功');
      // 20221003 暫時關閉同時更新公播盒子
      // broadcastBox
      //   .find({ query: { broadcastId: broadcastGroupId } })
      //   .then((res) => {
      //     if (res.data.length > 0) {
      //       for (let i = 0; i < res.data.length; i++) {
      //         const newRecord = {
      //           broadcastId: broadcastGroupId,
      //           broadcastBoxsId: [res.data[i]._id],
      //         };

      //         axios('/ezcon/api/enableBroadcast', {
      //           method: 'POST',
      //           headers: {
      //             authorization: window.localStorage['feathers-jwt'],
      //           },
      //           data: newRecord,
      //         })
      //           .then((res) => {
      //             Message.success('資料更新成功並發佈至公播盒');
      //           })
      //           .catch((err) => {
      //             console.log(err);
      //           });
      //       }
      //     } else {
      //       Message.success('資料更新成功');
      //     }
      // });
    }
  };
  const onBroadcastFinish = (value) => {
    const newBroadcast = broadcastData.filter((i) => i.value === value.title);
    const BroadcastData = [...newBroadcastData];
    BroadcastData.push({ ...newBroadcast[0] });
    setNewBroadcastData(BroadcastData);
    BroadcastForm.resetFields();
  };

  const onTypeDragCategoryEnd = (fromIndex, toIndex) => {
    const items = newBroadcastData; // 所有類別資料
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    const newBroadcastGroupId = [...items];
    setNewBroadcastData(newBroadcastGroupId);
    Message.success('拖曳成功');
  };

  return (
    <>
      <Button
        className={styles.buttonAdd}
        onClick={() => {
          setSettingBroadcastGroup(true);
          setBroadcastStatus('insert');
          form.resetFields();
        }}
      >
        新增公播群組
      </Button>
      <Card free>
        <Card.Content>
          <Table
            dataSource={broadcastGroup}
            bordered
            sortDirections={['descend', 'ascend', 'descend']}
          >
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={150}
              sorter={(a, b) => a.createdTime - b.createdTime}
              render={(value) => {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column title="建立者" dataIndex="userName" width={150} />
            <Table.Column title="名稱" dataIndex="title" width={150} />

            <Table.Column
              title="更新時間"
              dataIndex="updatedTime"
              width={150}
              sorter={(a, b) => a.createdTime - b.createdTime}
              render={(value) => {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column
              title="操作"
              width={200}
              lock="right"
              dataIndex="_id"
              render={(value, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setBroadcastGroupId(value);
                        setSettingBroadcast(true);
                      }}
                    >
                      播放
                    </Button>

                    <Button
                      type="normal"
                      onClick={() => {
                        setSettingBroadcastGroup(true);
                        setBroadcastGroupId(value);
                        setBroadcastStatus('update');
                        setNewBroadcastData(
                          record.broadcastContent.map((x) => x)
                        );
                        setBroadcastContent(
                          record.broadcastContent.map((x) => x)
                        );
                        console.log(record.broadcastContent);
                        form.setFieldsValue({
                          ...record,
                          broadcastGroupId: record.broadcastContent,
                        });
                      }}
                    >
                      編輯
                    </Button>
                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        Swal.fire({
                          title: `確定刪除公播(${record.title})資料?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            broadcast.remove(value).then(() => {
                              Swal.fire('刪除!', '此公播已刪除', 'success');
                              broadcast
                                .find({
                                  query: { broadcastGroup: { $exists: true } },
                                })
                                .then((res) => {
                                  setBroadcastGroup(res.data);
                                });
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>

          {/* 選擇公播群組 */}
          <Dialog
            hasMask
            className={styles.settingDialog}
            visible={settingBroadcastGroup}
            onOk={() => {
              form.submit();
            }}
            onClose={() => {
              setSettingBroadcastGroup(false);
            }}
            onCancel={() => {
              setSettingBroadcastGroup(false);
            }}
          >
            <h3>{broadcastStatus === 'insert' ? '新增' : '編輯'}公播群組</h3>
            <Form onFinish={onFinish} form={form}>
              <Form.Item
                name="title"
                label="群組名稱"
                rules={[
                  {
                    required: true,
                    message: '請輸入群組名稱',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              {/* <Form.Item
                name="broadcastGroupId"
                label="選擇公播"
                rules={[
                  {
                    required: true,
                    message: '請選擇公播',
                  },
                ]}
              >
                <Button
                  onClick={() => {
                    console.log(broadcastContent);
                    setNewBroadcastData(broadcastContent.map((x) => x));
                    setBroadcastValueDialog(true);
                  }}
                >
                  設定播放公播
                </Button>
              </Form.Item> */}
            </Form>
            <Form
              layout="inline"
              form={BroadcastForm}
              onFinish={onBroadcastFinish}
            >
              <Form.Item
                name="title"
                label="公播名稱"
                rules={[
                  {
                    required: true,
                    message: '請選擇公播名稱',
                  },
                ]}
              >
                <Select style={{ width: '200px' }}>
                  {broadcastData
                    .filter((i) => {
                      const newBroadcastFilter = newBroadcastData.filter(
                        (j) => j.value === i.value
                      );
                      if (newBroadcastFilter.length > 0) {
                        return false;
                      } else {
                        return true;
                      }
                    })
                    .map((i) => (
                      <Option value={i.value} key={i.value}>
                        {i.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => {
                    BroadcastForm.submit();
                  }}
                >
                  新增
                </Button>
              </Form.Item>
            </Form>
            <p style={{ marginTop: 10 }}>
              <font style={{ color: 'red' }}>*</font>可拖曳表格欄位變換順序
            </p>
            <ReactDragListView
              onDragEnd={(fromIndex, toIndex) =>
                onTypeDragCategoryEnd(fromIndex, toIndex)
              }
            >
              <Table dataSource={newBroadcastData} bordered>
                <Table.Column
                  align="center"
                  title="序號"
                  dataIndex="label"
                  render={(_value, _record, index) => index + 1}
                />
                <Table.Column
                  align="center"
                  title="公播名稱"
                  dataIndex="label"
                />
                <Table.Column
                  align="center"
                  title="操作"
                  width={150}
                  render={(_value, _record, index) => {
                    return (
                      <>
                        <Button
                          type="primary"
                          className={styles.buttonAdd}
                          warning
                          onClick={() => {
                            const broadcastData = [...newBroadcastData];
                            broadcastData.splice(index, 1);
                            setNewBroadcastData(broadcastData);
                          }}
                        >
                          刪除
                        </Button>
                      </>
                    );
                  }}
                />
              </Table>
            </ReactDragListView>
          </Dialog>

          {/* 設定播放公播編輯 */}
          <Dialog
            hasMask
            className={styles.settingDialog}
            visible={broadcastValueDialog}
            onOk={() => {
              setBroadcastContent(newBroadcastData.map((x) => x));
              form.setFieldsValue({ broadcastGroupId: newBroadcastData });
              setBroadcastValueDialog(false);
            }}
            onCancel={() => {
              setBroadcastValueDialog(false);
            }}
            onClose={() => {
              setBroadcastValueDialog(false);
            }}
          >
            <h3>設定播放公播</h3>
            <Form
              layout="inline"
              form={BroadcastForm}
              onFinish={onBroadcastFinish}
            >
              <Form.Item
                name="title"
                label="公播名稱"
                rules={[
                  {
                    required: true,
                    message: '請輸入公播名稱',
                  },
                ]}
              >
                <Select style={{ width: '150px' }}>
                  {broadcastData
                    .filter((i) => {
                      const newBroadcastFilter = newBroadcastData.filter(
                        (j) => j.value === i.value
                      );
                      if (newBroadcastFilter.length > 0) {
                        return false;
                      } else {
                        return true;
                      }
                    })
                    .map((i, index) => (
                      <Option key={index} value={i.value}>
                        {i.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => {
                    BroadcastForm.submit();
                  }}
                >
                  新增
                </Button>
              </Form.Item>
            </Form>
          </Dialog>

          {/* 選擇播放機盒 */}
          <Dialog
            hasMask
            className={styles.settingDialog}
            visible={settingBroadcast}
            onOk={() => {
              const newRecord = {
                broadcastId: broadcastGroupId,
                broadcastBoxsId: checkBroadcastBox,
              };

              axios('/ezcon/api/enableBroadcast', {
                method: 'POST',
                headers: {
                  authorization: window.localStorage['feathers-jwt'],
                },
                data: newRecord,
              })
                .then(() => {
                  setSettingBroadcast(false);
                })
                .catch((err) => {
                  console.log(err);
                });
            }}
            onClose={() => {
              setSettingBroadcast(false);
            }}
            onCancel={() => {
              setSettingBroadcast(false);
            }}
          >
            <h3>選擇播放機盒</h3>
            <Checkbox.Group
              dataSource={broadcastBoxData}
              onChange={(value) => setCheckBroadcastBox(value)}
            />
          </Dialog>
        </Card.Content>
      </Card>
    </>
  );
};

export default BroadCastList;
